// extracted by mini-css-extract-plugin
export default {"modal-actions":"PrivacyPolicy--modal-actions--EmRbZ","modalActions":"PrivacyPolicy--modal-actions--EmRbZ","modal":"PrivacyPolicy--modal--iqRSJ","link":"PrivacyPolicy--link--UN7dH"};